module.exports = __webpack_public_path__ + "static/media/vip_3.5736808b.svg";